import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { show as getPart } from "MODULES/parts/actions";
import { Map } from "immutable";
import { Paginator } from "@orange-marmalade/paginate-this";
import { loadRecord, withFilters } from "MODULES/shared/decorators";
import { PART } from "MODULES/parts/constants";
import BackToPart from "MODULES/parts/components/shared/BackToPart";
import Update from "MODULES/parts/components/RepairQuoteLineItems/Update/Update";
import Create from "MODULES/parts/components/RepairQuoteLineItems/Create/Create";
import SendRfqModal from "MODULES/parts/components/Detail/RepairQuotes/Send/SendRfqModal";
import Table from "./Table";

const listId = "part/repairQuoteLineItems";

function Title() {
  return (
    <div>
      <h2>Repair Quote History</h2>
    </div>
  );
}

const TitleWithFilters = withFilters(Title);

export function RepairQuoteLineItems({ part }) {
  const paginator = <Paginator listId={listId} />;
  const [modalOpen, setModalOpen] = useState(false);
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const [sendModalOpen, setSendModalOpen] = useState(false);
  const [lineItem, setLineItem] = useState(null);

  const sendRfq = l => {
    setLineItem(l);
    setSendModalOpen(true);
  };

  return (
    <div>
      <BackToPart part={part} />
      <button
        onClick={() => setModalOpen(true)}
        className="btn btn-primary btn-hollow pull-right"
        type="button"
      >
        <i className={`fa fa-fw fa-plus`} />
        Create Quote
      </button>
      <Create
        open={modalOpen}
        close={() => setModalOpen(false)}
        sendRfq={sendRfq}
        part={part.toJS()}
      />
      <Update
        open={updateModalOpen}
        close={() => setUpdateModalOpen(false)}
        lineItem={lineItem}
        setLineItem={setLineItem}
        sendRfq={sendRfq}
      />
      <SendRfqModal
        lineItem={lineItem}
        open={sendModalOpen}
        close={() => setSendModalOpen(false)}
      />
      <TitleWithFilters listId={listId} />
      <Table openEditModal={setUpdateModalOpen} setLineItem={setLineItem} />
      {paginator}
    </div>
  );
}

RepairQuoteLineItems.propTypes = {
  part: PropTypes.instanceOf(Map).isRequired
};

export default connect(state => ({
  part: state.partDetail.get(PART)
}))(
  loadRecord({
    reducer: "partDetail",
    name: PART,
    action: getPart
  })(RepairQuoteLineItems)
);



// WEBPACK FOOTER //
// ./app/modules/parts/components/RepairQuoteLineItems/RepairQuoteLineItems.jsx